export enum RoutePaths {
  SCOUTS = '/scouts',
  POSITIONS = '/positions',
  SEARCH = '/search',
  POSITION_APPLICATION = '/positions/application',
  MY_ACTIVITIES = '/positions/my-activities',
  MY_PROFILE = '/scouts/my-profile',
  REQUEST_FORM_EDUCATION = '/scouts/request-form/education',
  REQUEST_FORM_CAREER = '/scouts/request-form/career',
  REQUEST_FORM_START = '/scouts/request-form/start',
  REQUEST_FORM_JOB_SEARCH_STATUS = '/scouts/request-form/job-search-status',
  REQUEST_FORM_DONE = '/scouts/request-form/done',
  REQUEST_FORM_TOSS = '/scouts/request-form/toss',
  INTERESTED_IN_ME = '/scouts/interested-in-me',
  CHAT_ROOMS = '/chat-rooms',
  MY_CURATION = '/my-curation',
  POSITIONS_MATCHED = '/positions/matched',
  MY_PROFILE_ANALYSIS = '/scouts/my-profile/analysis',
  PROFILE_EXAMPLES = '/profile-examples',
  RESUME_ANALYZER = '/resume-analyzer',
  RESUME_ANALYZER_KEYWORD_MATCH = '/resume-analyzer/keyword-match',
  RESUME_ANALYZER_JOB_MATCH = '/resume-analyzer/job-match',
  RESUME_ANALYZER_IMPROVE_RESUME = '/resume-analyzer/improve-resume',
  SALARY_ANALYSIS_LANDING = '/salary-analysis/landing',
  SALARY_ANALYSIS_FORM = '/salary-analysis/form',
  SALARY_ANALYSIS_RESULT = '/salary-analysis/result',
  LANDING_STARTUP_SCOUT = '/landing/startup-scout',
  LANDING_RESUME = '/landing/resume',
}

export enum RouterQueryKey {
  IS_UPDATING_PROFILE = 'isUpdatingProfile',
  IS_UPDATING_CONDITION = 'isUpdatingCondition',
  SHOULD_APPLY_CONDITIONS = 'shouldApplyConditions',
  FROM_SITE = 'fromSite',
  STARTUP_ID = 'startupId',
  POSITION_ID = 'positionId',
  HAS_SENT_LINK = 'hasSentLink',
  IS_FROM_APPLICATION = 'isFromApplication',
  IS_FROM_REQUEST_FORM = 'isFromRequestForm', // 프로필 작성폼에서 내프로필 페이지로 넘어온 경우, 다시 작성폼으로 유도하지 않기 위해 사용
  RESOLVED_INFO_FILL = 'resolvedInfoFill', // true 혹은 ProfileCategoryId
  QUERY = 'query', // 검색어
  TAB = 'tab', // 검색 결과 페이지 내 탭 (positions, startups)
  STEP = 'step', // SALARY_ANALYSIS_FORM 단계 (request -> kakao -> position -> experience -> salary)
  IS_FROM_START = 'isFromStart', // start 페이지에서 연봉 진단 결과 페이지로 넘어온 경우
  ACTION = 'action', // 내 프로필 페이지에 특정 액션을 위해 들어온 경우 (ex. 프로필 대신 작성 요청, 보유 스킬 업데이트)
  IS_ANALYZE_MODE = 'isAnalyzeMode', // 서류합격 가능성 분석해보려고 채용 공고 탐색하고 있는지 여부
}

export enum SalaryAnalysisFormStep {
  REQUEST = 'request',
  KAKAO = 'kakao',
  POSITION = 'position',
  EXPERIENCE = 'experience',
  SALARY = 'salary',
}

export enum MyProfileActionQueryValue {
  OPEN_TOSS = 'open-toss',
  UPDATE_SKILLS = 'update-skills',
}

export const getQueryParam = (param: string | string[] | undefined) => {
  return typeof param === 'string' && param.length > 0 ? param : null
}
